<template>
<div class="chat">
	<div class="conteudo scroll" ref="item" :style="{'height': height - 60 + 'px'}">
		<div class="hacker-news-list" ref="item1">
			<div v-if="erro" class="text-center text-danger">
				<h4><strong><i class="fa fa-fw fa-times"></i>{{_traducao('global', 'erroConectarServidor')}}</strong></h4>
			</div>

			<div class="text-center"><flCarregando v-if="!conectado && !erro" /></div>
			<infinite-loading v-if="conectado" direction="top" ref="infiniteLoading" spinner="waveDots" @infinite="infiniteHandler">
				<div slot="no-more"><div style="padding:8px">{{_traducao('global','semMaisConversa').toUpperCase()}}</div></div>
				<div slot="no-results"><div style="padding:8px">{{_traducao('global','nenhumaConversaEncontrada').toUpperCase()}}</div></div>
			</infinite-loading>
			<div class="hacker-news-item" :class="item.class" v-for="(item, key) in list" :key="key">
				<!-- <span class="num">{{list.length - key}}</span> -->
				<div class="macro" :class="{'msj' : item.idUsuario != _idUsuario, 'msj-vc' : item.idUsuario == _idUsuario}" v-if="item.tipo == 'S'">
					<div class="container">
						<div class="row">
							<div class="col-xs-2 text-center col-xs-icon">
								<div class="row">
									<div class="col-xs-12 pd-fl-0">
										<i class="icon icon-cadastro_usuarios fa-fw icon-msg"></i>
									</div>
								</div>
							</div>
							<div class="col-xs-10" style="padding-left:0px">
								<div class="row">
									<div class="col-xs-12">
										<small v-if="item.idUsuario == _idUsuario">
											<strong>{{_traducao('global','voce')}}</strong>
										</small>
										<small v-else>
											<strong>{{item.nome.toUpperCase()}}</strong>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-xs-12">
										{{item.mensagem}}
									</div>
								</div>

								<div class="row" style="color:#777">
									<div class="col-xs-6">
										<small :title="item.data">{{item.dt}}</small>
									</div>
									<div class="col-xs-6 text-right">
										<small>
											<i class="fa pull-right fa-check" v-if="item.dataUTCEntregue != null" style="margin-left: -6px;margin-top:2px" aria-hidden="true"></i>
											<i class="fa pull-right fa-check" style="margin-top:2px" aria-hidden="true"></i>{{item.data.split(" ")[1]}}
										</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-else :class="{'msj-rta' : item.idUsuario != _idUsuario, 'msj-rta-vc' : item.idUsuario == _idUsuario}" class="macro">

					<div class="container">
						<div class="row">
							<div class="col-xs-2 text-center pr-0">
								<div class="row">
									<div class="col-xs-12 pr-0">
										<i class="icon fa icon-manutencao_celula_2 fa-fw icon-msg-2"></i>
									</div>
								</div>
							</div>
							<div class="col-xs-10">
								<div class="row">
									<div class="col-xs-12">
										<small v-if="item.idUsuario == _idUsuario">
											<strong>{{_traducao('global','voce')}}</strong>
										</small>
										<small v-else>
											<strong>{{item.nome.toUpperCase()}}</strong>
										</small>
									</div>
								</div>
								<div class="row">
									<div class="col-xs-12">
										{{item.mensagem}}
									</div>
								</div>

								<div class="row" style="color:#777">
									<div class="col-xs-6">
										<small :title="item.data">{{item.dt}}</small>
									</div>
									<div class="col-xs-6 text-right">
										<small>
											<i class="fa pull-right fa-check" v-if="item.dataUTCEntregue != null" style="margin-left: -6px;margin-top:2px" aria-hidden="true"></i>
											<i class="fa pull-right fa-check" style="margin-top:2px" aria-hidden="true"></i>
											{{item.data.split(" ")[1]}}
										</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>  
			</div>
		</div>
	</div>


	<div class="container-btn">
		<div class="col-xs-12" v-if="!erro && conectado">

			<a href="#" class="click-enviar"  v-if="!enviando" @click.prevent="clickEnviarMensgem()">
				<i class="fa fa-paper-plane-o fa-fw" aria-hidden="true"></i>{{_traducao('global','enviar')}}
			</a>

			<p v-if="enviando" class="click-enviar">
				<i class="fa fa-fw fa-spin fa-refresh"></i>{{_traducao('global','enviando')}}...
			</p>
			<textarea type="text" 	@keydown.enter.prevent="clickEnviarMensgem()" 
									@keyup="validaDescricao" 
									v-model="mensagem" 
									:rows="mensagem.length > 40 ? 2 : 1" 
				class="form-control text-area">
			</textarea>
		</div>
	</div>
</div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
export default {
	components: {
		InfiniteLoading,
	},

	props: ['height', 'aero', 'websoket', 'conectado', 'erro'],

	data() {
		return {
			list: [],
			primeiro: true,
			mensagem: '',
			enviando: false,
			tempo: null,
			estado : null,
		};
	},

	mounted () {
		this.recebeMensagem()
		this.loopProcessaLista()
	},
	  
	methods: {

		recebeMensagem(){


			this.websoket.on('mensagem', mensagem => {

				// console.log("menasgem", mensagem)

				let index = _.findIndex(this.list, l => { return l.id == mensagem.id})

				if(index > -1){
					this.list[index].dataUTCEntregue = mensagem.dataUTCEntregue
				} else {
					mensagem.dataUTC = mensagem.dataUTC.split('.')[0]
					mensagem.data = new moment.utc(mensagem.dataUTC).local().format($sessao.getDateFormat() + " HH:mm:ss")
					mensagem.class= 'animated bounceInLeft'
					mensagem.dt = moment(mensagem.data, $sessao.getDateFormat() + " HH:mm:ss").locale(this._getLangDp).fromNow()

					this.list.push(mensagem)
					this.list = this.processaLista(this.list)
					this.$nextTick(() => {
						this.$refs.item.scrollTop = 60000
					})
				}

			})
		},

		infiniteHandler($state) {

			var data = ''
			if(this.list.length == 0){
				data = moment().utc().format('YYYYMMDDTHHmmss') + 'Z'
			} else {
				data = this.list[0].dataUTC.replace('-', '').replace('-', '').replace(':', '').replace(':', '') + 'Z'
			}

			var imei = this.aero.imei
			this.websoket.invoke("ListaMensagens", this._keyServices, this.aero.imei, data).then(response => {

				// console.log(response)

				//se tiver dados
				if (response.length > 0) {
					response = this.processaLista(response)

					for(var i in response){

						var index = _.findIndex(this.list, o => {return o.id == response[i].id})

						if(index < 0){
							this.list.unshift(response[i])
						}
					}

					this.$nextTick(() => {

						if(this.primeiro){
							this.$refs.item.scrollTop = 60000
							this.primeiro = false
						} else {
							this.$refs.item.scrollTop = response.length * 70
						}
						$state.loaded();
					})
					
				} else {
					$state.complete();
				}
			})
		},

		clickEnviarMensgem (){

			if(this.mensagem.trim() != ''){

				this.enviando = true
				var imei = this.aero.imei

				var dt = {
					Key: this._keyServices,
					Mensagem: this.mensagem,
					IdUsuario: $sessao.getId(),
					Nome: $sessao.getNome(),
				}

				clearTimeout(this.tempo);

				this._httpService('/acessocliente/mensagem/' + imei, 'PUT', dt, retorno => {
					this.enviando = false
					retorno.dataUTC = retorno.dataUTC.split('.')[0]
					retorno.data = new moment.utc(retorno.dataUTC).local().format($sessao.getDateFormat() + " HH:mm:ss")
					retorno.class= 'animated bounceInLeft'
					retorno.dt = moment(retorno.data, $sessao.getDateFormat() + " HH:mm:ss").locale(this._getLangDp).fromNow();
					this.mensagem = ''
					this.list.push(retorno)

					this.list = this.processaLista(this.list)
					this.$nextTick(() => {
						this.$refs.item.scrollTop = 60000
					})
				})
			}
		},

		validaDescricao (event){

			var sub = 130 - this.mensagem.length;
			if(sub <= 0){
				this.mensagem = this.mensagem.substring(0, this.mensagem.length - Math.abs(sub))
			}
			return true
		},

		loopProcessaLista(){

			setTimeout(() => {
				this.list = this.processaLista(this.list)
				this.loopProcessaLista()
				// console.log("roidou")
			}, 60000)
		},

		processaLista(lista){

			return lista.map((item) => {
				item.data = new moment.utc(item.dataUTC).local().format($sessao.getDateFormat() + " HH:mm:ss")
				item.dt = moment(item.data, $sessao.getDateFormat() + " HH:mm:ss").locale(this._getLangDp).fromNow();
				item.class = ''
				item._index = new moment.utc(item.dataUTC).local().unix();

				return item
			})
		},
	},
}
</script>